<i18n lang="yaml">
en:
  billing: Billing
  current_plan: 'Current plan'
  available: 'Available'
  Free: Free
  change_plan: Change plan
  price: Price
  month: month
  active_until: 'Active until'
  cancel: Cancel
  used: Used
  cancel_plan_confirm: 'Are you sure you want to cancel the plan?'
  cancellable_help: 'Remove all servers to cancel the plan'
ru:
  billing: Оплата
  current_plan: 'Текущий план'
  Free: Бесплатно
  change_plan: Изменить план
  price: Цена
  month: месяц
  active_until: 'Активен до'
  cancel: Отменить
  used: Использовано
  cancel_plan_confirm: 'Вы уверены, что хотите отменить план?'
  cancellable_help: 'Удалите все сервера, чтобы отменить план'
</i18n>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useAlertStore, useAuthStore } from '@/store'
import { useMyFetch } from '@/utils'
import { useRoute } from 'vue-router'
import { computed, ref } from 'vue'
import { handleError } from '@/utils/errors'
import router from '@/router'
import { pricing_text } from '@/utils/pricing'

const { t } = useI18n()

const route = useRoute()
const organizationId = `${route.params.organization_id}`
const authStore = useAuthStore()
const alertStore = useAlertStore()
const orginfo = ref<any>()

async function fetchData() {
  const { data, error } = await useMyFetch(`organizations/${organizationId}`).get().json()
  if (error.value) {
    await handleError(error, router, authStore, alertStore, 'organizations:list')
  } else {
    orginfo.value = data.value
  }
}
await fetchData()

async function cancel() {
  if (confirm(t('cancel_plan_confirm'))) {
    const { error } = await useMyFetch(`organizations/${organizationId}/plan`).delete().json()
    if (error.value) {
      await handleError(error, router, authStore, alertStore)
    } else {
      await fetchData()
    }
  }
}

const isFreePlan = computed(() => {
  return orginfo.value.plan.price === 0
})
</script>

<template>
  <div class="card">
    <h4 class="card-header">{{ t('billing') }}</h4>
    <div class="card-body">
      <p>
        {{ t('current_plan') }}:
        <span class="badge rounded-pill bg-success">{{ t(orginfo.plan.name) }}</span>
      </p>

      <p class="card-text">
        <label for="servers">{{ t('used') }}:</label>
        <progress
          id="servers"
          class="align-middle ms-2"
          :max="orginfo.plan.max_servers"
          :value="orginfo.plan.used_servers"
        ></progress>
        <span class="ms-2">{{ orginfo.plan.used_servers }} / {{ orginfo.plan.max_servers }}</span>
      </p>

      <p class="card-text" v-if="orginfo.plan.price !== 0">
        {{ t('price') }}: {{ pricing_text(orginfo.plan, t('month')) }}
      </p>

      <p class="card-text">{{ t('active_until') }}: {{ orginfo.plan.active_until }}</p>

      <div class="mt-3">
        <router-link :to="{ name: 'organizations:billing:plans' }" class="btn btn-primary">{{
          t('change_plan')
        }}</router-link>
        <button
          v-if="!isFreePlan"
          :disabled="!orginfo.plan.cancellable"
          @click="cancel"
          class="btn btn-danger ms-2"
        >
          {{ t('cancel') }}
        </button>
        <label v-if="!isFreePlan && !orginfo.plan.cancellable" class="ms-2">{{
          t('cancellable_help')
        }}</label>
      </div>
    </div>
  </div>
</template>
